import React from 'react'

import useStyles from './styles'

const Rating = ({ rating = 0 }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {[1, 2, 3].map(val => (
        <img
          key={val}
          src={`/survey emojis/v2/survey${
            rating === val ? '_selected' : ''
          }_${val}.png`}
          alt={`Rating: ${val}${val === rating ? ' selected' : ''}`}
          className={classes.img}
        />
      ))}
    </div>
  )
}

export default Rating
